module.exports = __webpack_public_path__ + "media/3.fd884643.mp3";